module.exports = __webpack_public_path__ + "static/media/meal-finder.9348ec38.png";